"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnumRenderer = exports.EnumControl = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const antd_1 = require("antd");
const react_1 = require("@jsonforms/react");
const isStringOrNumberArray = (arr) => {
    return arr.every((value) => typeof value === "string" || typeof value === "number");
};
const EnumControl = (props) => {
    if (!props.visible)
        return null;
    const rules = [
        { required: props.required, message: `${props.label} is required` },
    ];
    const formItemProps = "formItemProps" in props.uischema ? props.uischema.formItemProps : {};
    const defaultValue = props.data ?? props.schema.default;
    const appliedUiSchemaOptions = props.uischema.options;
    const enumValue = props.schema.enum;
    const enumValueToLabelMap = appliedUiSchemaOptions?.enumValueToLabelMap;
    const options = enumValue && isStringOrNumberArray(enumValue)
        ? enumValue.map((value) => ({
            label: enumValueToLabelMap ? enumValueToLabelMap[value] : value,
            value: value,
        }))
        : [];
    let selector;
    switch (appliedUiSchemaOptions?.optionType) {
        case "radio":
            selector = ((0, jsx_runtime_1.jsx)(antd_1.Radio.Group, { defaultValue: defaultValue, options: options, onChange: (e) => {
                    props.handleChange(props.path, e.target.value);
                }, optionType: "button", buttonStyle: "solid" }));
            break;
        case "segmented":
            selector = ((0, jsx_runtime_1.jsx)(antd_1.Segmented, { defaultValue: defaultValue, options: options, onChange: (value) => {
                    props.handleChange(props.path, value);
                } }));
            break;
        case "dropdown":
        default:
            selector = ((0, jsx_runtime_1.jsx)(antd_1.Select, { showSearch: true, defaultValue: defaultValue, options: options, onChange: (option) => {
                    props.handleChange(props.path, option);
                }, filterOption: (inputValue, option) => {
                    const optionValue = option?.value?.toString() || "";
                    return (optionValue.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1);
                } }));
            break;
    }
    return ((0, jsx_runtime_1.jsx)(antd_1.Form.Item, { label: props.label, id: props.id, name: props.path, required: props.required, initialValue: defaultValue, rules: rules, validateTrigger: ["onBlur"], ...formItemProps, children: (0, jsx_runtime_1.jsx)(antd_1.Col, { children: selector }) }));
};
exports.EnumControl = EnumControl;
exports.EnumRenderer = (0, react_1.withJsonFormsControlProps)(exports.EnumControl);
